/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(examSetupCode) {
  var defer = $.Deferred();

  $.soap({
    body: {
      GetExamSetupQuestionsByCode: {
        $xmlns: 'http://dobs.pa.gov/nd/lookup/bpm/1.0',
        ExamSetupCode: examSetupCode
      }
    },
    blueprintArrays: ['GetExamSetupQuestionsByCodeResponse.ND_LU_ExamSetupQuestion'],
    blueprint: {
      examSetupQuestions: [
        '$..ND_LU_ExamSetupQuestion',
        {
          examSetupQuestionId: '$..ID',
          code: '$..Code',
          itemNumber: '$..ItemNumber',
          item: '$..Item',
          itemType: '$..ItemType',
          orderPos: '$..OrderPos',
          isLoanLog: '$..IsLoanLog',
          documentTypeId: '$..DocumentTypeID'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      _.each(response.examSetupQuestions, function(examSetupQuestion) {
        examSetupQuestion.isLoanLog = examSetupQuestion.isLoanLog === '1';
      });
      defer.resolve(response.examSetupQuestions);
    })
    .fail(function(err) {
      defer.reject();
    });

  return defer.promise();
};
